import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import ThreadPreviewItem from 'bundles/discussions/components/ThreadPreviewItem';

import 'css!./__styles__/ThreadPreviewList';

class ThreadPreviewList extends React.Component {
  static propTypes = {
    entries: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        snippet: PropTypes.object.isRequired,
        creator: PropTypes.object.isRequired,
        createdAt: PropTypes.number.isRequired,
        link: PropTypes.string.isRequired,
        title: PropTypes.string,
      })
    ),
    openLinkInNewTab: PropTypes.bool,
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'openLinkInNewTab' does not exist on type... Remove this comment to see the full error message
    const { openLinkInNewTab } = this.props;
    return (
      <ul className={classNames('rc-ThreadPreviewList', 'nostyle')}>
        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'entries' does not exist on type 'Readonl... Remove this comment to see the full error message */}
        {this.props.entries &&
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'entries' does not exist on type 'Readonl... Remove this comment to see the full error message
          this.props.entries.map((entry) => {
            const props = Object.assign(entry, {
              // TODO: Re-evaluate whether or not this key is sufficient
              key: entry.id,
              openLinkInNewTab,
            });

            return <ThreadPreviewItem {...props} />;
          })}
      </ul>
    );
  }
}

export default ThreadPreviewList;
